import React, { useContext } from 'react';
import { RootStoreContext } from '../../store/rootStore';
//import Platform from '../../utils';

const Footer = (props: any) => {
    const rootStore = useContext(RootStoreContext);

    const renderUser = () => {
        const user = rootStore.commonStore.userInfo;

        if (user) {
            const userName = user.userFullName || user.userName;

            if (userName)
                return (
                    <span className='user-role'>
                        {userName}: <b>{user.label}</b>
                    </span>);
            else
                return (
                    <span className='user-role'>
                        {user.label}
                    </span>);
        }
        return null;
    }

    return (
        <footer className='footer-container' id='page-footer'>
            <span>Copyright &copy; {new Date().getFullYear()} Resco spol. s r.o. All rights reserved.</span>
            { renderUser()}
        </footer>
    );
}

export default Footer;
